<!--
    Desarrollado por: Yonathan aviles
    // Fecha: 2022/12/217
-->


<template>
    <div>

        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active" slider-color="#ffbc00">
            <v-tab class="font-weight-black">Exportar Datos</v-tab>
            <v-tab class="font-weight-black">Importar DAtos</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item class="py-4">
                <exportar></exportar>
            </v-tab-item>

            <v-tab-item class="py-4">
                <importar></importar>
            </v-tab-item>
        </v-tabs-items>


    </div>
</template>



<script>
// import axios from '../../../helpers/axios'
import { mapMutations } from 'vuex'

import ImportarDatos from '@/views/Administrativo/MigracionDeDatos/components/ImportarDatos.vue'
import ExportarDatos from '@/views/Administrativo/MigracionDeDatos/components/ExportarDatos.vue';

export default {
    name: 'migracionDeDatos',

    components: {
        importar: ImportarDatos,
        exportar: ExportarDatos
    },


    data: () => ({
        paramComponente: { "id_modulo": 4, 'id_submodulo': 99 }, //sud_modulo y modulo
        session: sessionStorage, // variables de sesion del usuario
        tab: 0,
    }),


    mounted() {
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        ////////////////////////////////////////////////////////
    },
}
</script>